import {get,post,del,put} from './request';

/**
 * 获取组件分类
 * @returns {Array}
 */
export const getComponentCategory = async () => {
    let res = await get('api/CraftComponentCatalog/my');
    let data = res.data;
    if(data.success){
        return data.data;
    }
    return []
};

/**
 * 删除组件分类
 * @param {string} id 
 * @returns 
 */
export const delComponentCategory = async (id) => {
    let res = await del('api/CraftComponentCatalog/'+id);
    return res.data;
}

export const editComponentCategory = async (id,data) => {
    let res = await put('api/CraftComponentCatalog/'+id,data);
    return res.data;
}


export const addComponent = async (CraftComponentCatalogId,data)=>{
    let res = await post(`api/${CraftComponentCatalogId}/CraftElement`,data);
    return res.data;
}

export const delComponent = async (CraftComponentCatalogId,Id)=>{
    let res = await del(`api/${CraftComponentCatalogId}/CraftElement/${Id}`);
    return res.data;
}

export const getComponent = async (CraftComponentCatalogId)=>{
    let res = await get(`api/${CraftComponentCatalogId}/CraftElement`)
    return res.data;
}

export const editComponent = async (CraftComponentCatalogId,Id,data)=>{
    let res = await put(`api/${CraftComponentCatalogId}/CraftElement/${Id}`,data)
    return res.data
}

/**
 * 上传文件到云端
 * @param {string} typeid 
 * @param {FormData} formData 
 */
export const uploadCloud = async (typeid,formData)=>{
    let res = await post(`api/type/${typeid}/typeThreeD`,formData)
    return res.data;
}

/**
 * 上传组件到云端
 * @param {object} data 
 */
export const uploadComponentsCloud = async (data)=>{

}

/**
 * 上传拓扑页面数据
 * @param {number} TypeId 
 * @param {object} data 
 * @returns 
 */
export const uploadPagesCloud = async (TypeId,data)=>{
    let res = await post(`api/${TypeId}/TypeCraftTop`,data)
    return res.data;
}
/**
 * 获取所有的拓扑数据
 * @param {number} TypeId 
 * @returns 
 */
export const getPagesCloud = async (TypeId)=>{
    let res = await get(`api/${TypeId}/TypeCraftTop`)
    return res.data;
}
/**
 * 删除拓扑配置文件
 * @param {number} TypeId 
 * @param {number} Id 
 * @returns 
 */
export const delPagesCloud = async (TypeId,Id)=>{
    let res = await del(`api/${TypeId}/TypeCraftTop/${Id}`)
    return res.data;
}

/**
 * 编辑
 * @param {number} TypeId 
 * @param {number} Id 
 * @param {object} data 
 * @returns 
 */
export const editPagesCloud = async (TypeId,Id,data)=>{
    let res = await put(`api/${TypeId}/TypeCraftTop/${Id}`,data)
    return res.data;
}